<template>
  <div class="detail">
    <swiper :options="swiperOption">
      <swiper-slide v-for="(item, index) in list" :key="index" class="article-item">
        <img class="article-item-content" :src="item" alt="" />
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="mark" v-if="showMark">
      AI评审中...
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Detail',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    showMark: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'bullets'
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        // 分页器配置
        pagination: {
          type: this.type,
          el: '.swiper-pagination',
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        }
      }
    }
  }
}
</script>
<style lang="less">
.detail {
  position: relative;
  padding-bottom: 23px;
  text-align: center;
  background: #f7f7f8;

  .swiper-container {
    height: 100%;
  }

  .mark {
    position: absolute;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 17px;
    font-weight: 500;
    line-height: 24px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;
  }

  .article-item {
    width: 100%;
  }

  .swiper-pagination {
    bottom: 4px;
    left: 50%;
    z-index: 3;
    transform: translateX(-50%);
  }

  .article-item-content {
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }

  .my-bullet {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-left: 2px;
    margin-right: 2px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .my-bullet-active {
    width: 14px;
    height: 6px;
    background: #e02727;
  }

  .swiper-pagination-fraction {
    bottom: -3px;
    font-size: 13px;
    color: #333;
  }
}
</style>
